interface Props {
  imgUrl?: string;
  title?: string;
  className?: string;
}

export function AirPlaneWindow({ imgUrl, title, className }: Props) {
  return (
    <div
      className={`
        relative flex items-center justify-center
        w-[180px] h-[240px]
        p-2 rounded-[45%_/_30%]
        shadow-[0_0_25px_rgba(255,255,255,0.1),inset_0_4px_8px_rgba(255,255,255,0.2),inset_0_-4px_12px_rgba(0,0,0,0.3)]
        ${className}
      `}
      style={{
        background:
          'linear-gradient(27deg,rgba(137, 188, 219, 1) 0%, rgba(206, 227, 240, 1) 8%, rgba(241, 247, 251, 1) 24%, rgba(255, 255, 255, 1) 32%, rgba(206, 227, 240, 1) 51%, rgba(237, 244, 249, 1) 67%, rgba(237, 244, 249, 1) 81%, rgba(255, 255, 255, 1) 87%, rgba(136, 189, 221, 1) 100%)',
      }}
    >
      <div className='absolute -z-10 w-[300px] h-[400px] rounded-[50%_/_35%]' />
      <div
        className='
          w-full h-full overflow-hidden relative
          rounded-[40%_/_25%]
          border-[3px]
          bg-center bg-contain
        '
        style={{
          backgroundImage: `url(${imgUrl})`,
          backgroundRepeat: 'no-repeat',
        }}
      >
        {title}
      </div>
    </div>
  );
}
